// Interaction property names on the PDP Gallery Interacted Avo event (CON-8512).
// Exactly one is sent per call, always true.
export const GALLERY_INTERACTION = {
  LIFESTYLE_GALLERY_OPENED: 'lifestyleGalleryOpened',
  LIFESTYLE_GALLERY_CLOSED: 'lifestyleGalleryClosed',
  MEASURE_ACTIVATED: 'measureActivated',
  OPEN_STATE_ACTIVATED: 'openStateActivated',
  ZOOMED_INTERACTED: 'zoomedInteracted',
  AR_STARTED: 'arStarted',
};

// Which gallery an image view came from. 'Hero Gallery' is the legacy label for
// what the PDP now calls the Lifestyle Gallery. Configuration views are not
// sent to Avo.
export const GALLERY_IMAGE_LOCATION = {
  LIFESTYLE: 'Hero Gallery',
  CONFIGURATION: 'Configuration Gallery',
  MEASURE: 'Measure Gallery',
};
